import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const getPatientTimezone = () => {
  const timezone = localStorage.getItem("patient_timezone");

  if (timezone) {
    const decrypted = Decrypt_Value(timezone, "vozoportal");

    if (
      decrypted &&
      decrypted !== "null" &&
      decrypted !== "undefined" &&
      decrypted !== "not_set"
    ) {
      return decrypted;
    }
  }

  // DB/localStorage timezone is NULL/not_set
  // Use browser timezone only as a fallback for calculations
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return browserTimezone;
};

export const getShowPatientCurrentTime = () => {
  const value = localStorage.getItem("show_patient_current_time");

  if (value) {
    return Decrypt_Value(value, "vozoportal") === "1";
  }

  return false;
};

export const convertUTCToPatientTime = (utcDateTime, timezoneName = null) => {
  if (!utcDateTime) return null;

  const patientTimezone = timezoneName || getPatientTimezone();

  if (!patientTimezone) {
    return null;
  }
  const utcDate = new Date(utcDateTime.replace(" ", "T") + "Z");

  return {
    date: utcDate.toLocaleDateString("en-CA", {
      timeZone: patientTimezone,
    }),

    time: utcDate.toLocaleTimeString("en-US", {
      timeZone: patientTimezone,
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),

    dateTime: utcDate.toLocaleString("en-US", {
      timeZone: patientTimezone,
    }),

    raw: utcDate,
  };
};

// console.log("==================================");
// console.log("UTC Input:", utcDateTime);
// console.log("Patient Timezone:", patientTimezone);
// console.log(
//   "Converted Date:",
//   utcDate.toLocaleDateString("en-CA", {
//     timeZone: patientTimezone,
//   }),
// );
// console.log(
//   "Converted Time:",
//   utcDate.toLocaleTimeString("en-US", {
//     timeZone: patientTimezone,
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   }),
// );
// console.log("==================================");

//   return {
//     date: utcDate.toLocaleDateString("en-CA", {
//       timeZone: patientTimezone,
//     }),

//     time: utcDate.toLocaleTimeString("en-US", {
//       timeZone: patientTimezone,
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     }),

//     dateTime: utcDate.toLocaleString("en-US", {
//       timeZone: patientTimezone,
//     }),

//     raw: utcDate,
//   };
// };

export const formatPatientTimeRange = (
  startUtc,
  endUtc,
  timezoneName = null,
) => {
  if (!startUtc || !endUtc) return "";

  const start = convertUTCToPatientTime(startUtc, timezoneName);

  const end = convertUTCToPatientTime(endUtc, timezoneName);

  return `${start.time} - ${end.time}`;
};

// export const getTimezoneLabel = (utcDateTime, timezoneName = null) => {
//   if (!utcDateTime) return "";

//   const patientTimezone = timezoneName || getPatientTimezone();

//   if (!patientTimezone) return "";

//   try {
//     if (
//       patientTimezone === "Asia/Kolkata" ||
//       patientTimezone === "Asia/Calcutta"
//     ) {
//       return "IST";
//     }

//     const utcDate = new Date(utcDateTime.replace(" ", "T") + "Z");

//     const timezonePart = new Intl.DateTimeFormat("en-US", {
//       timeZone: patientTimezone,
//       timeZoneName: "short",
//     })
//       .formatToParts(utcDate)
//       .find((part) => part.type === "timeZoneName");

//     return timezonePart?.value || patientTimezone;
//   } catch (error) {
//     return patientTimezone;
//   }
// };

export const formatToPatientTimezone = (
  dateTimeStr,
  formatStr = "MM-DD-YYYY hh:mm A",
) => {
  if (!dateTimeStr) return "";
  const tz = getPatientTimezone();
  return dayjs(dateTimeStr).tz(tz).format(formatStr);
};

export const getPatientCurrentDateTime = () => {
  const patientTimezone = getPatientTimezone();

  if (!patientTimezone) {
    return {
      date: "",
      time: "",
    };
  }

  const now = new Date();

  return {
    date: now.toLocaleDateString("en-CA", {
      timeZone: patientTimezone,
    }),

    time: now.toLocaleTimeString("en-US", {
      timeZone: patientTimezone,
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
  };
};

export const convertPatientTimeToProviderTime = (
  dateStr,
  timeStr,
  providerTz,
  formatStr = "YYYY-MM-DD hh:mm A",
) => {
  const patientTz = getPatientTimezone();
  const dateTimeStr = `${dateStr} ${timeStr}`;
  const timeInPatientTz = dayjs.tz(dateTimeStr, formatStr, patientTz);

  if (!providerTz) return timeInPatientTz;

  return timeInPatientTz.tz(providerTz);
};

export const isSlotDisabledForPatient = (
  patientDate,
  slotTime,
  rawDisableState,
  availability,
  providerTimezone,
) => {
  const patientTz = getPatientTimezone();

  if (!providerTimezone || providerTimezone === patientTz) {
    return rawDisableState ?? true;
  }

  try {
    const providerDateTime = convertPatientTimeToProviderTime(
      patientDate,
      slotTime,
      providerTimezone,
      "YYYY-MM-DD hh:mm A",
    );

    const providerTimeStr = providerDateTime.format("hh:mm A");

    const normTarget = dayjs(providerTimeStr, [
      "hh:mm A",
      "h:mm A",
      "HH:mm",
    ]).format("hh:mm A");

    let match = null;
    if (availability && typeof availability === "object") {
      for (const section of ["morning", "afternoon", "evening"]) {
        const list = availability[section] || [];
        match = list.find((s) => {
          const t = s?.time || s?.pc_startTime || s?.start_time;
          if (!t) return false;
          return (
            dayjs(t, ["hh:mm A", "h:mm A", "HH:mm"]).format("hh:mm A") ===
            normTarget
          );
        });
        if (match) break;
      }
    }

    if (match) {
      return match.disable ?? true;
    }

    return rawDisableState ?? true;
  } catch (err) {
    console.error("Error in isSlotDisabledForPatient:", err);
    return rawDisableState ?? true;
  }
};
